import type { AppSelectOption } from 'shared/UI/UIKit/Select';

export enum TableFilterFieldType {
  INPUT = 'input',
  SELECT = 'select',
  MULTI_SELECT = 'multiSelect',
  NUMBER = 'number',
}

export type TableFilterField = {
  key: string;
  name: string;
  label: string;
  type: TableFilterFieldType;
  placeholder?: string;
  //SELECT | MULTI_SELECT
  options?: AppSelectOption[];
  isLoadableOptions?: boolean;
  loading?: boolean;
  //NUMBER
  min?: number;
  precision?: number;
  className?: string;
  dropdownClassName?: string;
  dropdownMatchSelectWidth?: boolean;
};

export type TableFilterProps = {
  fields: TableFilterField[];
  submitBtnText: string;
  resetBtnText: string;
  fieldsValue?: Record<string, any>;
  onClose(): void;
  onSubmit: (values: any) => void;
  onLoadOptions?: (fieldName: string) => void;
};
